export default __webpack_public_path__ + "static/media/312.21c3f57b.png";